module.exports = __webpack_public_path__ + "static/media/icon_Video_W.5e8c6d15.svg";